export default __webpack_public_path__ + "static/media/iconeDesempenho.d91d52e6.png";